import { Component } from '@angular/core';

@Component({
  selector: 'app-why-we-different',
  templateUrl: './why-we-different.component.html',
  styleUrls: ['./why-we-different.component.scss'],
  standalone: false
})
export class WhyWeDifferentComponent {
  readonly philosophyItems = [
    {
      title: 'Objetivo',
      description: 'El objetivo general del Centro de Investigaciones en Desarrollo Humano es contribuir al compromiso de la universidad con la excelencia en las actividades de generación de conocimiento, con el fin de posicionarse como referente de investigación a nivel regional, nacional e internacional.',
      alignment: 'left',
      imageUrl: '/assets/img/filosofia-objetivo.jpg'
    },
    {
      title: 'Misión',
      description: 'El Centro de Investigaciones en Desarrollo Humano tiene como misión fomentar la investigación en el campo del desarrollo humano mediante el impulso de la actividad científica, a través de sus grupos de investigación, incentivando las pasantías de formación doctoral y creando los mecanismos para la divulgación del quehacer científico de la Universidad del Norte.',
      alignment: 'right',
      imageUrl: '/assets/img/filosofia-mision.png'
    },
    {
      title: 'Visión',
      description: 'Consecuente con la visión de la Universidad del Norte, el Centro de Investigaciones en Desarrollo Humano aspira a consolidarse como un referente en investigación inter y multidisciplinar que contribuya al conocimiento y al desarrollo de una sociedad inclusiva, mediante la investigación y el fomento de las actividades I+D.',
      alignment: 'left',
      imageUrl: '/assets/img/filosofia-vision.jpg'
    }
  ] as const;
}
